import { addB2bAPIParams } from '../b2b';
import { restrictMainCurrency } from '../shopify-market/restrict-user.js';
import { addParamsLocale, getCustomerId, getTenantId } from '../utils';

/**
 * @type {import('./index.d').getProductById}
 */
export const getProductById = async (context, productId) => {
  if (!productId) return [];

  let params = {
    product_id: productId,
    shop: getTenantId(),
    country: window.Shopify.country || '',
    customer_id: getCustomerId(),
  };

  params = addParamsLocale(params);

  if (context.app.b2b?.enabled) {
    addB2bAPIParams(params, context);
  }

  const queryParams = new URLSearchParams(params);

  const response = await fetch(`${context?.app?.productUrl}?${queryParams.toString()}`);
  if (response.status === 200) {
    const data = await response.json();

    if (data.meta) {
      const { money_format, money_format_with_currency, currency } = data.meta;
      restrictMainCurrency(context, { money_format, money_format_with_currency, currency });
    }

    return data;
  }

  return {};
};
